module.exports = __webpack_public_path__ + "static/media/Actions.eec4afd3.png";